<div class="property-value" *ngIf="(propertiesQuery.selectEntity(spec?.PropertyId) | async) as property">
  <div class="row">
    <label class="col-form-label w-100 text-center fst-italic {{labelCss}}" *ngIf="showLabel" [attr.title]="(spec.LineSource?.Code || '') + ' | ' + (spec.MappingSource?.Code || '')">
      {{spec.Alias || property.Name}}
    </label>
    <ng-container [ngSwitch]="property.TypeClv">
      <div class="col" *ngSwitchCase="Classificators.PropertyType.Numeric">
        <div class="input-group" [ngClass]="{'readonly': readonly, 'justify-content-center': readonly}">
          <ng-container [ngSwitch]="readonly">
            <ng-container *ngSwitchCase="true">
              <span class="input-group-text col" *ngIf="property.IsMultiValue; else singleValue">
                <ng-container *ngFor="let value of (spec.Value | jsonParse: [])">
                  {{value | decimalPlaces: property.RoundingFactor}}
                </ng-container>
              </span>
              <ng-template #singleValue>
                <span class="input-group-text col">{{spec.NumericValue | decimalPlaces: property.RoundingFactor}}</span>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <ng-container *ngIf="property.IsMultiValue; else singleValue">
                <ng-select #select class="select-sm form-control tags-only" bindValue="Key" bindLabel="Value" [mesNumberInput]="1" [allowSign]="true"
                           [readonly]="readonly"
                           [placeholder]="spec.Default?.toString() | unitNumber: property.UnitId: true" appendTo="body" name="number-{{spec.Id}}"
                           [multiple]="true"
                           [addTag]="addNumericValue"
                           [ngModel]="spec.Value | jsonParse: []"
                           (ngModelChange)="onNumericChanged(spec, $event, property.IsMultiValue)">
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-icon left" (click)="clear(item); select.close()" aria-hidden="true">×</span>
                    <span class="ng-value-label" [title]="item.Key">{{item.Key}}</span>
                  </ng-template>
                </ng-select>
              </ng-container>
              <ng-template #singleValue>
                <input class="form-control form-control-sm" name="number-{{spec.Id}}" mesStopArrowKeyPropagation [class.is-invalid]="isInvalid" [decimalPlaces]="property.RoundingFactor"
                       [allowSign]="true" [(mesNumberInput)]="spec.NumericValue" (onChange)="onChanged()">
              </ng-template>
            </ng-container>
          </ng-container>
          <ng-container [ngTemplateOutlet]="unitTemplate"></ng-container>
          <ng-container [ngTemplateOutlet]="traceTemplate"></ng-container>
        </div>
      </div>
      <div class="col input-group flex-nowrap" *ngSwitchCase="Classificators.PropertyType.Choice">
        <mes-web-classificator-value-select name="choice-{{spec.Id}}" [readonly]="readonly"
                                            [items]="classificatorValuesQuery.getAll$ | async | where: 'ClassificatorId': property.ChoiceTypeClassificatorId"
                                            [entityId]="spec.ValueClv"
                                            [entityIds]="property.IsMultiValue ? (spec.Value | jsonParse: []) : undefined"
                                            [multiple]="property.IsMultiValue"
                                            [isInvalid]="isInvalid"
                                            [initOpened]="initOpened"
                                            (entityIdChange)="spec.ValueClv = $event; onChanged()"
                                            (entityIdsChange)="onMultiChoiceChanged(spec, $event); onChanged()"
                                            [classificatorId]="property.ChoiceTypeClassificatorId"></mes-web-classificator-value-select>
        <ng-container [ngTemplateOutlet]="unitTemplate"></ng-container>
      </div>
      <div class="col" *ngSwitchCase="Classificators.PropertyType.Text">
        <div class="input-group" [ngClass]="{'readonly': readonly, 'justify-content-center': readonly}">
          <ng-container *ngIf="!readonly">
            <ng-container *ngIf="property.IsMultiValue; else singleValue">
              <ng-select #select class="select-sm form-control tags-only" bindValue="Key" bindLabel="Value"
                         [readonly]="readonly"
                         [placeholder]="spec.Default" appendTo="body" name="number-{{spec.Id}}"
                         [multiple]="true"
                         [addTag]="addTextValue"
                         [ngModel]="spec.Value | jsonParse: []"
                         (ngModelChange)="onTextChanged(spec, $event, property.IsMultiValue)">
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-icon left" (click)="clear(item); select.close()" aria-hidden="true">×</span>
                  <span class="ng-value-label" [title]="item.Key">{{item.Key}}</span>
                </ng-template>
              </ng-select>


            </ng-container>
            <ng-template #singleValue>
            <textarea name="text-{{spec.Id}}" class="form-control" [class.is-invalid]="isInvalid" rows="1" [(ngModel)]="spec.Value" (change)="onChanged()" mesStopArrowKeyPropagation autosize></textarea>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="readonly">
            <span class="d-block text-center bg-transparent border-0 text-break" style="white-space: pre-wrap; overflow-wrap: break-word">{{spec.Value}}</span>
          </ng-container>
          <ng-container [ngTemplateOutlet]="traceTemplate"></ng-container>
        </div>
      </div>
      <div class="col" *ngSwitchCase="Classificators.PropertyType.Html">
        <button type="button" class="btn btn-sm" [ngClass]="isInvalid ? 'btn-outline-danger' : 'btn-outline-primary'" [disabled]="readonly" (click)="edit.emit(spec); onChanged()" id="edit-{{spec.Id}}">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </button>
      </div>
      <div class="col" *ngSwitchCase="Classificators.PropertyType.DateTime">
        <app-date-time-picker [showTime]="false" [disabled]="readonly" [isInvalid]="isInvalid" [(ngModel)]="spec.DateTimeValue" (ngModelChange)="onChanged()" inputDatetimeFormat="dd.MM.yyyy" id="datetime-{{spec.Id}}" name="datetime-{{spec.Id}}"></app-date-time-picker>
      </div>
      <div class="col" *ngSwitchCase="Classificators.PropertyType.Json">
        <button type="button" class="btn btn-sm" [ngClass]="isInvalid ? 'btn-outline-danger' : 'btn-outline-primary'" [disabled]="readonly" (click)="edit.emit(spec); onChanged()" id="edit-{{spec.Id}}">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </button>
      </div>
      <div class="col" *ngSwitchCase="Classificators.PropertyType.FileLink">
        <div class="input-group" *ngLet="spec.Value | toFileLinkModel as fileLink">
          <input type="text" class="form-control border" placeholder="Filename" disabled [ngModel]="fileLink.FileName || fileLink.Path" name="fileLink">
          <div class="input-group-append">
            <button *ngIf="!readonly" class="btn btn-sm btn-outline-default" type="button" (click)="edit.emit(spec); onChanged()">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#paper-clip"></svg>
            </button>
            <a class="btn btn-sm btn-outline-default" type="button" [href]="fileLink.Path | safe: 'url'" target="_blank">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#document"></svg>
            </a>
          </div>
        </div>
      </div>
      <ng-template #unitTemplate>
        <span *ngIf="property.UnitId" class="input-group-text py-0">{{property.UnitId | unit}}</span>
      </ng-template>
      <ng-template #traceTemplate>
        <button class="btn btn-outline-default btn-sm wx-36" type="button" (click)="showTrace()" *ngIf="spec.Trace.hasFormula()">
          <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrow-top-right-on-square'">
          </svg>
        </button>
      </ng-template>
    </ng-container>

  </div>
</div>
